import { Alert, ToggleGroup, View } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { CategoryList } from "./CategoryList";

export const ProgramLevels = ({
  selectedAcSub,
  programs,
  relevantDataIsInitialized,
}) => {
  const { t } = useTranslation();
  const fetchLevelTitle = (program) => {
    if (program.label) {
      return `${t("programs.levelOutcomes")}: ${program.name}`;
    } else {
      let title = `${t("programs.programOutcomes")}: ${program.degreeName}`;
      if (program.abbreviation) {
        title += ` (${program.abbreviation})`;
      }
      return title;
    }
  };

  return !relevantDataIsInitialized ? (
    <Skeleton
      count={3}
      style={{ height: 54, borderRadius: 5, marginBottom: 15 }}
    />
  ) : programs.length > 0 ? (
    programs.map((program, progIndex) => (
      <ToggleGroup
        key={progIndex}
        margin="small 0"
        toggleLabel={t("plo.ploToggleScreenReaderLabel")}
        summary={fetchLevelTitle(program)}
      >
        <View display="block" padding="small">
          <CategoryList program={program} />
        </View>
      </ToggleGroup>
    ))
  ) : (
    !selectedAcSub && (
      <Alert variant="info">
        {t("plo.selectHierarchy") + ". " + t("plo.selectAcSub")}
      </Alert>
    )
  );
};
